import React, { useState, useContext, useEffect } from "react";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import WalletBG from "../../images/wallet.png";
import TherapistSidebar from "../../inc/TherapistSidebar";
import CalenderIcon from "../../images/calender.svg";
import TimeIcon from "../../images/time.svg";
import DocImg from "../../images/userimg3.png";
import { Link } from "react-router-dom";
import { FaAlignLeft } from "react-icons/fa";
import { FiAlertCircle } from "react-icons/fi";
import ConstConfig from "../../../utility/configs/constConfig";
import Functions from "../../../utility/services/Functions";
import ApiService from "../../../utility/services/ApiService";
import { toast } from "react-toastify";
import { AuthContext } from "../../../utility/services/AuthContext";
import ImageConfig from "../../../utility/configs/imageConfig";
import Button from "react-bootstrap/Button";
import NoDataFoundIcon from "../../images/no_data_found.svg";
import { Image } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import UserAvatar from "../../common/UserAvatar";
const TherapistEarnings = () => {
  ///////////////////////////////////// LOGICAL VARIABLES ////////////////////////////////////////

  const [loadmoreLoading, setLoadmoreLoading] = useState(false);

  const { get_earning_details, get_web_content_details } = ApiService();
  const { setLoading, loading } = useContext(AuthContext);
  const {
    consoleService,
    calculateAge,
    get_gender,
    formet_date,
    formet_time,
    scheduledTimeForTherapist,
    get_price,
    isLastPage,
  } = Functions();

  const [filterHideShow, setfilterHideShow] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  /////////////////////////////////////// DATA VARIABLES ///////////////////////////////////////////

  const [totalEarning, setTotalEarning] = useState(0);
  const [bookings, setBookings] = useState([]);
  const [content, setContent] = useState("");
  //////////////////////////////////////// USE EFFECTS  /////////////////////////////////////////////

  useEffect(() => {
    fetch_initial_details();
  }, []);

  //////////////////////////////////////// FUNCTIONS //////////////////////////////////////////////

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  async function fetch_initial_details() {
    setLoading(true);
    try {
      const res = await get_earning_details(1);
      const content_res = await get_web_content_details();

      if (res.status === 1 && content_res.status === 1) {
        setBookings([...res.data.booking_details]);
        setTotalPages(res.data.total_entries);
        setTotalEarning(res.data.earning_total);
        setContent(content_res.data[0].earning_info_content);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch lists function = ", err);
    }
  }

  const loadmore_details = async () => {
    if (!loadmoreLoading) {
      setLoadmoreLoading(true);
      const Inc_pageNo = Number(pageNo) + 1;
      try {
        const res = await get_earning_details(Inc_pageNo);
        if (res.status === 1) {
          setBookings([...bookings, ...res.data.booking_details]);
          setTotalPages(res.data.total_entries);
          setTotalEarning(res.data.earning_total);
          setPageNo(Inc_pageNo);
          setLoadmoreLoading(false);
        }
      } catch (err) {
        setLoadmoreLoading(false);
        consoleService("Error in loadmore upcoming list api", err);
      }
    }
  };
  return (
    <React.Fragment>
      <>
        <div className="breadHidePhone">
          <BannerSection banner={Banner} name={"Home"} title={"My Earnings"} />
        </div>
        <section className="py-5 useraccount bg-light_dash">
          <div className="container">
            <div className="row">
              <div
                className={`col-xl-3 col-md-4 ${
                  filterHideShow ? "leftShow" : "leftHide"
                }`}
              >
                <TherapistSidebar />
              </div>
              {!loading && (
                <div className="col-xl-9 col-md-8 tabBox fulltabBox earning_details_fulltabBox">
                  <div className="filterBox">
                    <Link className="filterIcon" onClick={sideBarHide}>
                      <FaAlignLeft />
                    </Link>
                  </div>
                  <div className="dashboard-widg-bar d-block">
                    <div className="dashboard_body">
                      <Tooltip
                        id="my-tooltip-u"
                        className="tooltip-custom-container"
                      />
                      <h4 className="mb-4 ft-medium">
                        My Earnings{" "}
                        <span
                          data-tooltip-id="my-tooltip-u"
                          data-tooltip-content={content}
                        >
                          <FiAlertCircle />
                        </span>
                      </h4>

                      {!loading && !totalEarning ? (
                        <div className="no_datafound">
                          <Image
                            src={NoDataFoundIcon}
                            alt="No Data Found"
                            className="img-fluid noFoundImg2"
                          />
                        </div>
                      ) : (
                        !loading && (
                          <React.Fragment>
                            <div
                              className="wallert_bg"
                              style={{ backgroundImage: `url(${WalletBG})` }}
                            >
                              <h2>$ {totalEarning.toFixed(2)}</h2>
                              <h4>All time earnings</h4>
                            </div>

                            <h4 className="mb-4 mt-4 ft-medium">
                              Transaction History
                            </h4>

                            {bookings.map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  className="docListitem docListitemmb"
                                >
                                  <div className="d-flex align-items-center">
                                    <UserAvatar
                                      profileImage={item.profile_img}
                                      firstName={item.first_name || item.name}
                                      lastName={item.last_name}
                                      size="md"
                                      className="imgDoc"
                                      alt={`${item.first_name} ${item.last_name} profile`}
                                    />
                                    <div className="l_content docListitemhistory">
                                      <h2 style={{ color: "#172228" }}>
                                        {`${item.first_name} ${item.last_name}`}{" "}
                                        |
                                        <strong className="strage">
                                          {calculateAge(item.dob)}{" "}
                                          {get_gender(item.gender)}
                                        </strong>
                                      </h2>
                                      <div className="timeflex">
                                        <div className="ps-0 py-2">
                                          <img
                                            src={TimeIcon}
                                            className="imgDoc"
                                            alt=""
                                          />
                                          <span>
                                            {scheduledTimeForTherapist(
                                              item.pricing_details,
                                              item.pricing_id
                                            )}
                                          </span>
                                          <span className="slashicon">|</span>
                                          <span> $ {item.price}</span>
                                        </div>
                                      </div>
                                      <div className="timeflex">
                                        <img
                                          src={CalenderIcon}
                                          className="imgDoc"
                                          alt=""
                                        />
                                        <h4>
                                          Last : {formet_date(item.time)} |{" "}
                                          {formet_time(item.time)}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                            {!loadmoreLoading &&
                              !isLastPage(pageNo, totalPages, 10) && (
                                <div className="text-center mt-3">
                                  <Button
                                    className="btn btnNew btn-primary"
                                    onClick={() => {
                                      loadmore_details();
                                    }}
                                  >
                                    Next
                                  </Button>
                                </div>
                              )}
                          </React.Fragment>
                        )
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
};

export default TherapistEarnings;
